function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1A{fill:#282828;}.cls-2A{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}.cls-3A{fill:#fff;}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bb4f8c91-a67b-4b5f-8b8d-10a60f18869a"
}, /*#__PURE__*/React.createElement("g", {
  id: "fc9febf0-13f1-4df3-847c-3738c216880d"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "a79e3b5c-b7ca-4345-a71b-2babe9dcd2e0",
  className: "cls-1A",
  cx: 51.4,
  cy: 50.3,
  rx: 51,
  ry: 50.5
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2A",
  d: "M67.7,79.1H35.1A12.5,12.5,0,0,1,22.6,66.6V34A12.5,12.5,0,0,1,35.1,21.5H67.7A12.5,12.5,0,0,1,80.2,34V66.6A12.5,12.5,0,0,1,67.7,79.1Z"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3A",
  cx: 41.95,
  cy: 59.14,
  r: 5.81
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-3A",
  x: 39.45,
  y: 29.68,
  width: 5,
  height: 41.24,
  rx: 2.5
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-3A",
  x: 58.26,
  y: 29.68,
  width: 5,
  height: 41.24,
  rx: 2.5
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3A",
  cx: 60.76,
  cy: 42.64,
  r: 5.81
});

const SvgMixer = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Ebene_1",
  "data-name": "Ebene 1",
  viewBox: "0 0 102 101",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMixer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mixer.cf8ed526.svg";
export { ForwardRef as ReactComponent };